import React, { ComponentProps } from 'react';
import { ImageTypes, ProfileImage } from '../../../types/api/ImageType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { Hint } from '../../../_lib/components/Hint';
import { HiddenParam, SonForm, TextParam } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';

type PortalAvatarEditProps = {
  image: ProfileImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: SonForm<
    NestedParam<
      'imageuploadparams',
      'imageupload',
      | ImageFileParam<'image'>
      | HiddenParam<'width'>
      | HiddenParam<'height'>
      | HiddenParam<'y'>
      | HiddenParam<'x'>
      | TextParam<'alt'>
      | TextParam<'copyright'>
      | TextParam<'caption'>
    >
  >;
};

export function PortalAvatarEdit({ image, form, cropping, viewportSwitch }: PortalAvatarEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('PortalAvatar');

  return (
    <>
      <div className="portal-avatar">
        <Hint message={t('faviconMessage')} />
        <p className="font-regular-15-21">{t('additionalMessage')}</p>
      </div>
      <ImageUploadForm
        imageDescriptionName={t('imageDescriptionName')}
        cropping={cropping}
        viewportSwitch={viewportSwitch}
        form={form}
        imageType={ImageTypes.portalAvatar}
        formId="portal-avatar-image-upload-form"
        uuid={uuid}
        initialImage={image}
        refresh={refresh}
      />
    </>
  );
}

export const PortalAvatarEditView = asFetchableView(PortalAvatarEdit);
export type PortalAvatarEditView = ComponentProps<typeof PortalAvatarEditView>;
